import {
  BehaviorSubject,
  Observable,
  Subject,
  of as observableOf,
  throwError as observableThrowError,
  of,
  throwError,
} from 'rxjs';

import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, tap } from 'rxjs/operators';
// operators

// map response to objects

import { Configuration } from '../../app.constants';
import {
  AccountRequest,
  BusinessUnit,
  Industry,
} from '../../core/models/business-unit.model';

import { EraPermission } from '../../core/models/engagement.model';
import { LeadSource } from '../../core/models/lead-source.model';
import { IShell } from '../../core/models/shell.model';
import { Solution } from '../../core/models/solution.model';
//this is for ERA filter
import { AssessmentArray } from '../../core/models/assessment.model';
import { IRiskAssessment } from '../../core/models/risk-assessment.model';

import { Guid } from 'guid-typescript';
import { IOppRequest } from '../../core/models/opp-request.model';
import { OpportunityServiceView } from '../../core/models/opportunity-services.model';
import { RevenueScheduleListView } from '../../core/models/revenue-schedule-list-view.model';
import { APIUrlConstants } from '../constants/api-url-constants';
import { OpportunityStage } from '../constants/opportunity-stage-constants';
import { GuidService } from './guid.service';
import { ErrorMessagesConstants } from '../constants/error-messages-constants';
import { EngagementList, EngagementListResponse } from '../../core/models/engagement-list.model';
import { UploadView } from '../../core/models/contract.model';
import { GenericDropdown } from '../models/generic-models/generic-dropdown.model';

@Injectable()
export class ShellService implements OnInit {
  public clientUrl = 'api/clients';
  public employeeUrl = 'api/Employees';
  public emdUrl = this.employeeUrl + '/emd';
  public emUrl = this.employeeUrl + '/em';
  public createBudgetUrl = 'https://ibudget.protiviti.com/newmain';
  public getShellUrl = 'api/Engagements';
  public createOpportunityUrl = 'api/Opportunities';
  public getSolutionsUrl = 'api/operationunits';
  public getLeadSourceUrl = 'api/leadSources';
  public departmentUrl = 'api/Departments';
  public businessUnitUrl = 'api/BusinessUnits';
  public industryUrl = 'api/Industries';
  public createShellUrl = 'api/Engagements';
  public createAccountUrl = 'api/accountrequests';
  public uploadUrl = 'api/UploadFiles';
  public bathUploadUrl = 'api/batchUpload';
  public IANatureUrl = 'api/ianaturalofworks';
  public OpportunityStageUrl = 'api/dropdownvalues/opportunitystages';
  public OpportunityClosedStageUrl = 'api/dropdownvalues/closedstages';
  public engagementUrl = 'api/engagements/';
  public OpportunityServicesUrl = 'api/opportunityServices';
  public OpportunityServices: any[] = [];
  public OpportunityServicesId: any[] = [];
  public opportunityCurrenciesUrl = 'api/Currencies?pageSize=100';
  public supportRequestUrl = 'api/SupportRequests';
  public ecosystemUrl = 'api/ecosystems';
  public apiBaseUrl = '';
  public ERAUrl = '';
  public iBudgetUrl = '';
  private ERAFilterUrl = ''; //this is for ERA filter
  public createBudgetPOSTBody = {};
  public currentUrl: string = '';
  public teamMessage: string = '';
  public teamStatus: number = 0;
  public teamUrl: string = '';
  public externalTeamStatus: number  = 0;
  public errorMessage!: string;
  public salesforceUrlPrefix: any;
  public salesforceLightningUrlPrefix: any;
  serviceData!: string;
  public businessUnitName: string = '';
  public opportunityURL: string = '';
  public currentShell = <IShell>{}; // create an empty object of an interface
  public currentShells = [<IShell>{}]; // create an empty object of an interface
  isShellSaveButtonClicked: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isMenuActivatedChange: Subject<boolean> = new Subject<boolean>();
  clientSelectedChange: Subject<any> = new Subject<any>();
  leadEMDSelectedChange: Subject<any> = new Subject<any>();
  leadEMSelectedChange: Subject<any> = new Subject<any>();
  opportunityMDSelectedChange: Subject<any> = new Subject<any>();
  opportunityOwnerSelectedChange: Subject<any> = new Subject<any>();
  opportunityCurrencySelectedChange: Subject<any> = new Subject<any>();
  primaryKeyBuyerSelectedChange: Subject<any> = new Subject<any>();
  noContactPrimaryKeyBuyerChange: Subject<boolean> = new Subject<boolean>();
  noAccountPrimaryKeyBuyerChange: Subject<boolean> = new Subject<boolean>();
  ecosystemSelectedChange: Subject<any> = new Subject<any>();
  assistantChange: Subject<any> = new Subject<any>();
  departmentSelectedChange: Subject<any> = new Subject<any>();
  indsutrySelectedChange: Subject<any> = new Subject<any>();
  ERAStatusChange: Subject<boolean> = new Subject<boolean>();
  budgetsChange: Subject<any> = new Subject<any>();
  shellsChange: Subject<any> = new Subject<any>();
  opportunityChange: Subject<any> = new Subject<any>();
  serviceOfferingSelectedChange: Subject<any> = new Subject<any>();
  leadSourceSelectedChange: Subject<any> = new Subject<any>();
  EMChecklistChange: Subject<{}> = new Subject<{}>();
  accountInformationChange = new BehaviorSubject({});
  opportunityStatusChecklistChange: Subject<{}> = new Subject<{}>();
  accountClientChange: Subject<{}> = new Subject<{}>();
  allFieldsSavedChange: Subject<boolean> = new Subject<boolean>();
  allOpportunityFieldsSavedChange: Subject<boolean> =
    new BehaviorSubject<boolean>(false);
  opportunityServicesChange: Subject<any[]> = new Subject<any[]>();
  public selectedBU: string = '';
  //public isEmeaBU: boolean = false;
  selectedIndustry: string = '';
  public savedSolutionName: string = '';
  private headers: HttpHeaders;
  EmployeeSelectedChange: Subject<any> = new Subject<any>();
  EraUserSelectedChange: Subject<any> = new Subject<any>();
  canDeleteChange: Subject<boolean> = new Subject<boolean>();
  checkOpportunityStatus: Subject<any> = new Subject<any>();
  resetOppStage: BehaviorSubject<IShell> = new BehaviorSubject<any>({});
  engagementIdChange: BehaviorSubject<string> = new BehaviorSubject<string>('');
  currentProposalDocumentNames: Subject<string[]> = new Subject<string[]>();

  type!: string | null;
  currentUserName!: string;
  public spoLinkURL: string = '';

  static getModifiedMessage(modifiedDate: string,
    modifierName: string)
   : string {
    return  'Modified on ' +
    Intl.DateTimeFormat(navigator.language, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(new Date(modifiedDate)) +
    ' by ' +
    modifierName;
  }

  static getShellName(name: string) : string {
    return name.length > 50
    ? name.substr(0, 50) + '...'
    : name;
  }

  //getting employees for emd
  public getUsersAvailable(url: string) {
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map((response) => {
          var json = <any>response;
          return {
            data: json.list,
            totalCount: json.totalCount,
          };
        }),
      )
      .toPromise();
  }

  public getUsersWithPermissions(url: string) {
    return this.http
      .get(`${this._configuration.iManageApi}${url}`, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map((response) => {
          var json = <any>response;

          return {
            data: json.list,
            totalCount: json.totalCount,
          };
        }),
      )
      .toPromise();
  }

  pkicSelectedUsers: any[] = [];
  public getPkicRequestCCUsers(url: string, pkicSelectedUsers?: any[]) {
    this.pkicSelectedUsers = pkicSelectedUsers!;
    let that = this;
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map((response) => {
          var json = <any>response;
          let users = [];
          for (let i = 0; i < json.list.length; i++) {
            if (that.pkicSelectedUsers.length > 0) {
              if (that.pkicSelectedUsers.indexOf(json.list[i].id) == -1) {
                users.push(json.list[i]);
              }
            } else {
              users.push(json.list[i]);
            }
          }

          return {
            data: users,
            totalCount: json.totalCount,
          };
        }),
      )
      .toPromise();
  }

  public getEmployeesForPursuitTeamMembers(url: string) {
    this.headers.append('Access-Control-Allow-Origin', '*');
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map((response) => {
          var json = <any>response;

          return {
            data: json.list,
            totalCount: json.totalCount,
          };
        }),
      )
      .toPromise();
  }

  setEmployeeId(employee: {}) {
    this.EmployeeSelectedChange.next(employee);
  }

  public extractPkicRequestCCUsers(response: HttpResponse<any>): any[] {
    let body = <any>response;
    let results = new Array();
    for (let i = 0; i < body.list.length; i++) {
      results.push({
        id: body.list[i].id,
        name: body.list[i].name,
        jobFunction: body.list[i].jobFunction,
        departmentId: body.list[i].departmentId,
        department: body.list[i].department,
        operationUnit: body.list[i].operationUnit,
        resourceName: body.list[i].resourceName,
        employeeId: body.list[i].employeeId,
      });
    }
    return results;
  }

  public AddUserToEngagement = (
    eraId: string,
    usersToAdd: any[],
  ): Observable<any> => {
    let toAdd1 = JSON.stringify(usersToAdd);
    let toAdd2 = '"EmployeeIds": ' + toAdd1;
    let toAdd = '{' + toAdd2 + '}';
    return this.http.post(
      this.apiBaseUrl + this.engagementUrl + eraId + '/permission',
      toAdd,
      { withCredentials: true, headers: this.headers },
    );
  };

  public DeleteUserFromoEngagement = (
    engagementId: string,
    usersToDelete: string,
  ): Observable<any> => {
    return this.http.delete(
      this.apiBaseUrl +
        this.engagementUrl +
        engagementId +
        '/permission?employeeIds=' +
        usersToDelete,
      { withCredentials: true, headers: this.headers },
    );
  };

  public GetEmployees(url: string) {
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(map(this.extractTotalEmployeesCount), catchError(this.handleError));
  }

  public GetListOfNonSelectedUsersCount(id: string) {
    return this.http
      .get(this.apiBaseUrl + this.engagementUrl + id + '/notifyingemployees?', {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map(this.extractTotalEmployeesCount), catchError(this.handleError));
  }

  public extractTotalEmployeesCount(response: any) {
    return response.pageSize * response.totalPageCount;
  }

  public GetListOfNonSelectedUsers(id: string, totalCount: number) {
    return this.http
      .get(
        this.apiBaseUrl +
          this.engagementUrl +
          id +
          `/notifyingemployees?pageSize=${totalCount}`,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map((r: any) => this.extractListOfNonSelectedUsers),
        catchError(this.handleError),
      );
  }

  public extractListOfNonSelectedUsers(response: HttpResponse<any>): any {
    let body = <any>response;
    let results = new Array();
    for (let i = 0; i < body.list.length; i++) {
      results.push({
        id: body.list[i].id,
        name: body.list[i].name,
        jobFunction: body.list[i].jobFunction,
        departmentId: body.list[i].departmentId,
        department: body.list[i].department,
        operationUnit: body.list[i].operationUnit,
        resourceName: body.list[i].resourceName,
        employeeId: body.list[i].employeeId,
      });
    }
    return { results: results, totalCount: body.totalCount };
  }

  public SubmitPKICRequestForm(supportRequest: any) {
    return this.http
      .post(this.apiBaseUrl + this.supportRequestUrl, supportRequest, {
        withCredentials: true,
        headers: this.headers,
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  public AddCCUserToPKICRequest = (
    eraId: string,
    usersToAdd: any[],
  ): Observable<any> => {
    let toAdd1 = JSON.stringify(usersToAdd);
    let toAdd2 = '"EmployeeIds": ' + toAdd1;
    let toAdd = '{' + toAdd2 + '}';
    return this.http.post(
      this.apiBaseUrl + this.engagementUrl + eraId + '/permission',
      toAdd,
      { withCredentials: true, headers: this.headers },
    );
  };

  public RemoveCCUserFromPKICRequest = (
    engagementId: string,
    usersToDelete: string,
  ): Observable<any> => {
    return this.http.delete(
      this.apiBaseUrl +
        this.engagementUrl +
        engagementId +
        '/permission?employeeIds=' +
        usersToDelete,
      { withCredentials: true, headers: this.headers },
    );
  };

  public updateEnterpriseCollaborators(
    engagementId: string,
    names: string,
    pursuitTeamUrl: string,
  ): Observable<any> {
    if (pursuitTeamUrl.includes('/pursuitteam')) {
      pursuitTeamUrl = pursuitTeamUrl.slice(0, pursuitTeamUrl.length - 12);
    }
    return this.http
      .patch(
        this.apiBaseUrl + pursuitTeamUrl,
        [
          {
            op: 'replace',
            path: '/EnterpriseCollaborators',
            value: names,
          },
        ],
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        tap(() => {
          console.log('Shell.Service.updateEnterpriseCollaborators success');
        }),
        catchError(this.handleError),
      );
  }

  public AddUserToPursuitTeam = (
    engagementId: string,
    usersToAdd: any[],
    pursuitTeamUrl: string,
  ): Observable<any> => {
    let toAdd = '{"EmployeeIds": ' + JSON.stringify(usersToAdd) + '}';
    return this.http.post(this.apiBaseUrl + pursuitTeamUrl, toAdd, {
      withCredentials: true,
      headers: this.headers,
    });
  };

  public DeleteUserFromoPursuitTeam = (
    engagementId: string,
    usersToDelete: string,
    pursuitTeamUrl: string,
  ): Observable<any> => {
    return this.http.delete(
      this.apiBaseUrl + pursuitTeamUrl + '?employeeIds=' + usersToDelete,
      { withCredentials: true, headers: this.headers },
    );
  };

  public GetAll2 = (url: string): Observable<AssessmentArray> => {
    var url = this.ERAFilterUrl + 'api/assessments/';
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map((response: any) => response),
      );
  };
  public getEngagementPermissionCanManage(
    id: string,
  ): Observable<EraPermission> {
    return this.http
      .get(this.apiBaseUrl + this.engagementUrl + id + '/permission', {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map((res) => <EraPermission>res));
  }

  getShellFilter(url: string): Observable<EngagementListResponse<EngagementList>> {
    return this.http
      .get<EngagementListResponse<EngagementList>>(url, { withCredentials: true, headers: this.headers });
  }

  getShell(id: string): Observable<IShell> {
    if (id === '0') {
      // new shell, no shell to retrieve
      return observableOf();
    }
    return this.http
      .get(this.apiBaseUrl + this.getShellUrl + '/' + id, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map(x => {
          return this.extractDataToShellObject(x);
        }), // map responses to shell
        catchError(this.handleError),
      );
  }

  // POC:  make 2nd call to api/assessments when there are no shells returned
  getERAfromAssistant(id: string): Observable<{}> {
    return this.http
      .get(this.ERAUrl + 'api/assessments/' + id, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map(x => { return this.extractERADataToAssistant(x); }),
        catchError(this.handleError),
      );
  }

  extractERADataToAssistant(response: any): {} {
    let body = response;
    let result = {};
    result = {
      opportunity: body.opportunity,
      clientSalesForce: body.client.salesforceUrl,
    };
    return result;
  }

  handleAssistantError(error: any): Observable<any> {
    console.log('handleError Assistant');
    console.log(error);
    if(error){
      return throwError(() => {error.status, error.error, error.statusText, error.message});
    } else {
      return throwError(() => 'Server Error' );
    }
  }

  setDeleteStatus(canDelete: boolean) {
    this.canDeleteChange.next(canDelete);
  }
  checkOppStatus(oppStatus: any) {
    this.checkOpportunityStatus.next(oppStatus);
  }

  setEMChecklist(shell: IShell) {
    this.currentShell = shell;
    let salesforceUrl: boolean;
    let riskAssessmentStatus: boolean;
    let mainProjectActivated: boolean;
    let shellClosed: boolean;
    let riskAssessmentUrl: boolean;
    let primaryKeyBuyer: boolean;
    let opportunityClosed: boolean;
    this.salesforceUrlPrefix = this.getConfiguration().validurl + '006';
    this.salesforceLightningUrlPrefix =
      this.getConfiguration().validlightningurl + 'r/opportunity/006';

    if (
      this.currentShell.opportunityURL != null &&
      (this.currentShell.opportunityURL
        .toLowerCase()
        .startsWith(this.salesforceUrlPrefix.toLowerCase()) ||
        this.currentShell.opportunityURL
          .toLowerCase()
          .startsWith(this.salesforceLightningUrlPrefix.toLowerCase()))
    ) {
      salesforceUrl = true;
    }

    // rule #2: 2.	If user is linking ERA: Only approved ERA can be linked
    // EM Checklist: both SF and ERA approved (done)
    // Assistant: opportunity should display link in opportunity section
    // ERA link shows in the ERA section
    if (this.currentShell.riskAssessment && this.currentShell.riskAssessment.status == 'APPROVED') {
      riskAssessmentStatus = true;
    }

    // rule #3: If user unlinks ERA / Delete ERA: (for Deleting an ERA created through the Shell the user has to unlink it first)
    // EM Checklist: SF Opp. created & ERA approved UNCHECKED
    // Assistant: opportunity in ass disappear (TODO)
    // ERA link in assistant disappears (Done)

    if (this.currentShell.hasActivatedSubBudget) {
      mainProjectActivated = true;
    }
    if (this.currentShell.status == 'Closed') {
      shellClosed = true;
    } else {
      shellClosed = false;
    }

    if (this.currentShell.riskAssessmentUrl) {
      riskAssessmentUrl = true;
      if (!this.currentShell.riskAssessmentId) {
        // Copy & paste URL for ERA
        riskAssessmentStatus = true;
      }
    } else {
      riskAssessmentUrl = false;
    }

    if (this.currentShell.type === 1) {
      if (this.currentShell.opportunityPrimaryKeyBuyerId && this.currentShell.opportunityPrimaryKeyBuyerId !== 'ba8068c4-1502-48bb-9156-6576414d1445') {
        primaryKeyBuyer = true;
      } else {
        primaryKeyBuyer = false;
      }
      if (this.currentShell.opportunityStageId === OpportunityStage.OPPSTG_ClosedWonKey.toLocaleLowerCase() 
        || this.currentShell.opportunityStageId === OpportunityStage.OPPSTG_ClosedLostKey.toLocaleLowerCase() 
        || this.currentShell.opportunityStageId === OpportunityStage.OPPSTG_ClosedUnqualifiedKey.toLocaleLowerCase() 
        || this.currentShell.opportunityStageId === OpportunityStage.OPPSTG_ClosedProDeclineKey.toLocaleLowerCase()) {
        opportunityClosed = true;
      } else {
        opportunityClosed = false;
      }
    }

    this.EMChecklistChange.next({
      salesforceUrl: salesforceUrl!,
      riskAssessmentStatus: riskAssessmentStatus!,
      mainProjectActivated: mainProjectActivated!,
      shellClosed: shellClosed,
      riskAssessmentUrl: riskAssessmentUrl,
      primaryKeyBuyer: primaryKeyBuyer!,
      opportunityClosed: opportunityClosed!,
      type: this.currentShell.type,
    });
  }

  setAccountInformation(shell: IShell) {
    //let accountName: string = '';
    if (!shell) {
      return;
    }

    const accountType = shell.accountType;
    const isPursuitCandidateEnabled = shell.isClientAcceptanceWorkflowEnalbed;
    let accountMD: string = '';
    let clientStatus = '';
    let globalExecutive: string = '';
    let globalDesignation: string = '';
    let industry: string = '';
    let subindustry: string = '';
    let location: string = '';
    let contractSummaryUrl: string = '';
    let isPursuitCandidateHistoryUrlEnabled: boolean = false;
    let pursuitCandidateHistoryUrl: string = '';
    let target: string = '';
    let isActive: string = '';
    let isClientAcceptanceWorkflowEnalbed: boolean = false;

    const accountName = shell.clientName ? shell.clientName : '';
    let accountUrl = shell.salesforceUrl != '' ? shell.salesforceUrl : '';

    if (shell.client) {
      if (shell.client.isActive == null) {
        isActive = 'N/A';
      } else if (shell.client.isActive == true) {
        isActive = 'Active';
      } else {
        isActive = 'Dormant';
      }

      if (shell.client.isTarget == null) {
        target = 'N/A';
      } else if (shell.client.isTarget == true) {
        target = 'Yes';
      } else {
        target = 'No';
      }

      globalExecutive = shell.client.globalAccountExecutive ? shell.client.globalAccountExecutive.name : '';
      switch (shell.client.globalDesignation) {
        case 5:
          globalDesignation = 'Target Account';
          break;
        case 4:
          globalDesignation = 'Regional Account';
          break;
        case 3:
          globalDesignation = 'Strategic Account';
          break;
        case 2:
          globalDesignation = 'Major Account';
          break;
        case 1:
          globalDesignation = 'Key Account';
          break;
        default:
          globalDesignation = '';
      }
      accountMD = shell.client.managingDirector ? shell.client.managingDirector.name : '';
      industry = shell.client.industry ? shell.client.industry.name : '';
      subindustry = shell.client.subIndustry ? shell.client.subIndustry.name : '';
      contractSummaryUrl = shell.client.contractSummaryUrl ? shell.client.contractSummaryUrl : '';
      isPursuitCandidateHistoryUrlEnabled = shell.client && shell.client.isAcceptanceWorkflowSubmitted;
      if (shell.client.city) {
        location = location + shell.client.city;
        if (shell.client.state || shell.client.country) {
          location = location + ', ';
        }
      }
      if (shell.client.state) {
        location = location + shell.client.state;
        if (shell.client.country) {
          location = location + ', ';
        }
      }
      if (shell.client.country) {
        location = location + shell.client.country;
      }
      if (isPursuitCandidateHistoryUrlEnabled) {
        pursuitCandidateHistoryUrl = this._configuration.pursuitCandidateHistoryUrl.replace('_', shell.clientId);
      }
    }

    isClientAcceptanceWorkflowEnalbed =
      Boolean(shell.isClientAcceptanceWorkflowEnalbed) && shell.type === 1;

    this.accountInformationChange.next({
      accountName: accountName,
      target: target,
      clientStatus: clientStatus,
      accountMD: accountMD,
      globalExecutive: globalExecutive,
      globalDesignation: globalDesignation,
      industry: industry,
      subindustry: subindustry,
      location: location,
      accountUrl: accountUrl,
      contractSummaryUrl: contractSummaryUrl,
      accountType: accountType,
      isPursuitCandidateEnabled: isPursuitCandidateEnabled,
      isPursuitCandidateHistoryUrlEnabled: isPursuitCandidateHistoryUrlEnabled,
      pursuitCandidateHistoryUrl: pursuitCandidateHistoryUrl,
      isActive: isActive,
      isClientAcceptanceWorkflowEnalbed: isClientAcceptanceWorkflowEnalbed,
    });
  }

  modalRevenueScheduleAmount: any[] = [];
  extractRevenueScheduleAmount(opportunityServiceId: string, index: number) {
    this.modalRevenueScheduleAmount[index] = 0;
    this.getRevenueSchedule(opportunityServiceId)
      .then((response: any) => {
        if (!response.data.length || response.data.length == 0) {
          this.modalRevenueScheduleAmount[index] = 0;
        } else {
          for (var i = 0; i < response.data.length; i++) {
            this.modalRevenueScheduleAmount[index] += response.data[i].amount;
          }
        }
      })
      .catch((error) => {
        console.log('Revenue Schedule Amount from api error: ' + error);
      });
  }

  getSolutions(): Observable<Solution[]> {
    let url = this.apiBaseUrl + this.getSolutionsUrl;
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(map(this.extractSolutionsTree), catchError(this.handleError));
  }

  getLeadSource(): Observable<any[]> {
    let url = this.apiBaseUrl + this.getLeadSourceUrl;
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(map(this.extractLeadSource), catchError(this.handleError));
  }

  getSolutionsSearch(searchAll: string): Observable<Solution[]> {
    let url =
      this.apiBaseUrl + this.getSolutionsUrl + '?searchAll=' + searchAll;
    if (url.includes('&')) {
      url = url.replace('&', '%26');
    }
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(map(this.extractSolutionsTree), catchError(this.handleError));
  }

  getLeadSourceSearch(searchAll: string): Observable<any[]> {
    let url =
      this.apiBaseUrl + this.getLeadSourceUrl + '?searchAll=' + searchAll;
    if (url.includes('&')) {
      url = url.replace('&', '%26');
    }
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(map(this.extractLeadSource), catchError(this.handleError));
  }

  public GetSolutionName = (id: string): Observable<any> => {
    let url = this.apiBaseUrl + this.getSolutionsUrl + '/' + id;
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(map((res) => <any>res));
  };

  public getLeadSourceName(id: string): Observable<any> {
    let url = this.apiBaseUrl + this.getLeadSourceUrl + '/' + id;
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(map((res) => <any>res));
  }

  private extractSolutionsTree(response: any): Solution[] {
    let body = response;
    let results: Solution[] = [];

    for (var i = 0; i < body.list.length; i++) {
      results.push(
        new Solution(
          body.list[i].id,
          body.list[i].id,
          '',
          '',
          body.list[i].code + ' - ' + body.list[i].name,
          '',
          '',
          body.list[i].name,
          body.list[i].code,
          '0',
          true,
        ),
      );
      for (var j = 0; j < body.list[i].solutionSegments.length; j++) {
        results.push(
          new Solution(
            body.list[i].solutionSegments[j].id,
            '',
            body.list[i].solutionSegments[j].id,
            '',
            '',
            body.list[i].solutionSegments[j].name,
            '',
            body.list[i].solutionSegments[j].name,
            body.list[i].solutionSegments[j].code,
            body.list[i].solutionSegments[j].operationUnitId,
            true,
          ),
        );
        for (
          var k = 0;
          k < body.list[i].solutionSegments[j].serviceOfferings.length;
          k++
        ) {
          results.push(
            new Solution(
              body.list[i].solutionSegments[j].serviceOfferings[k].id,
              body.list[i].id,
              body.list[i].solutionSegments[j].id,
              body.list[i].solutionSegments[j].serviceOfferings[k].id,
              '',
              body.list[i].solutionSegments[j].name,
              body.list[i].solutionSegments[j].serviceOfferings[k].name,
              '',
              body.list[i].solutionSegments[j].serviceOfferings[k].code,
              body.list[i].solutionSegments[j].serviceOfferings[
                k
              ].solutionSegmentId,
              false,
            ),
          );
        }
      }
    }
    return results;
  }

  private extractLeadSource(response: any): any[] {
    let body = <any>response;
    let results = [];

    for (var i = 0; i < body.list.length; i++) {
      results.push(
        new LeadSource(
          body.list[i].id,
          body.list[i].id,
          '',
          '',
          body.list[i].name,
          '',
          '',
          body.list[i].name,
          '',
          GuidService.DEFAULT_EMPTY_GUID,
          body.list[i].isParent,
        ),
      );
      if (body.list[i].children) {
        for (var j = 0; j < body.list[i].children.length; j++) {
          results.push(
            new LeadSource(
              body.list[i].children[j].id,
              '',
              body.list[i].children[j].id,
              '',
              '',
              body.list[i].children[j].name,
              '',
              body.list[i].children[j].name,
              '',
              body.list[i].children[j].parentId,
              body.list[i].children[j].isParent,
            ),
          );
          if (body.list[i].children[j].children) {
            for (var k = 0; k < body.list[i].children[j].children.length; k++) {
              results.push(
                new LeadSource(
                  body.list[i].children[j].children[k].id,
                  body.list[i].id,
                  body.list[i].children[j].id,
                  body.list[i].children[j].children[k].id,
                  '',
                  body.list[i].children[j].name,
                  body.list[i].children[j].children[k].name,
                  '',
                  '',
                  body.list[i].children[j].children[k].parentId,
                  body.list[i].children[j].children[k].isParent,
                ),
              );
            }
          }
        }
      }
    }
    return results;
  }

  private extractDataToShellObject(response: any): IShell {
    let body = response;
    var result = <IShell>{}; // create an empty object of an interface
    if (!this._configuration) {
      this._configuration = new Configuration();
    }
    result.id = body.id;
    if (!body.isChangeOrderOpportunity) {
      let hostUrl = this._configuration.iManageWeb
        ? this._configuration.iManageWeb
        : window.location.host + '/';
      if (body.type == 0)
        result.shellUrl =
          this._configuration.iManageWeb +
          'engagements/shellLinkExisting/' +
          body.id;
      else if (body.type == 1)
        result.shellUrl = hostUrl + 'engagements/shellEdit/' + body.id;
    }

    result.name = body.name;
    result.description = body.description;
    result.clientId = body.clientId;
    result.closedDate = body.closedDate;
    result.clientName = body.client ? body.client.name : '';
    result.clientNameSalesForceUrl = body.client
      ? body.client.salesforceUrl
      : '';
    result.client = body.client ? body.client : null;
    result.budgetStatus = body.budgetStatus;
    result.businessUnitId = body.businessUnitId;
    result.businessUnitName = body.businessUnit ? body.businessUnit.name : '';
    result.isRevenueScheduleRequiredForBU = body.businessUnit
      ? body.businessUnit.isRevenueScheduleRequired
      : false;
    result.isTeamsEnabled = body.businessUnit
      ? body.businessUnit.isTeamsEnabled
      : false;
    result.businessUnit = body.businessUnit ? body.businessUnit : null;
    result.externalTeamUrl = body.externalTeamUrl;
    result.businessUnitCurrency = body.businessUnit
      ? body.businessUnit.currency
      : '';
    result.economicBuyingCenterId = body.economicBuyingCenterId;
    result.economicBuyingCenterOther = body.economicBuyingCenterOther;
    result.departmentId = body.departmentId;
    result.departmentName = body.department ? body.department.name : '';
    result.engagementManagingDirectorId = body.engagementManagingDirectorId;
    result.engagementManagingDirectorName = body.engagementManagingDirector
      ? body.engagementManagingDirector.name
      : '';
    result.engagementManagingDirectorIsDeleted = body.engagementManagingDirector
      ? body.engagementManagingDirector.isDeleted
      : false;
    result.enterpriseCollaborators = body.enterpriseCollaborators
      ? body.enterpriseCollaborators
      : '';
    result.OpportunityManagingDirectorId = body.opportunityManagingDirectorId;
    result.OpportunityManagingDirectorName = body.opportunityManagingDirector
      ? body.opportunityManagingDirector.name
      : '';
    result.OpportunityManagingDirectorIsDeleted =
      body.opportunityManagingDirector
        ? body.opportunityManagingDirector.isDeleted
        : false;
    result.engagementManagerId = body.engagementManagerId;
    result.engagementManagerName = body.engagementManager
      ? body.engagementManager.name
      : '';
    result.engagementManagerIsDeleted = body.engagementManager
      ? body.engagementManager.isDeleted
      : false;
    result.salesforceUrl = body.client ? body.client.salesforceUrl : '';
    result.solutionName = body.operationUnit ? body.operationUnit.name : '';
    result.solutionCode = body.operationUnit ? body.operationUnit.code : '';
    result.solutionSegmentName = body.operationUnit
      ? body.operationUnit.solutionSegments[0].name
      : '';
    result.serviceOfferingName = body.operationUnit
      ? body.operationUnit.solutionSegments[0].serviceOfferings[0].name
      : '';
    result.serviceOfferingId = body.operationUnit
      ? body.operationUnit.solutionSegments[0].serviceOfferings[0].id
      : '';
    result.opportunityStageId = body.opportunityStage
      ? body.opportunityStage.id
      : '';
    result.primaryWinLossReasonId = body.primaryWinLossReasonId
      ? body.primaryWinLossReasonId
      : '';
    result.opportunityStageName = body.opportunityStage
      ? body.opportunityStage.name
      : '';
    result.opportunityStageProbability = body.opportunityStage
      ? body.opportunityStage.probability
      : '';
    result.opportunityOwnerId = body.opportunityOwnerId
      ? body.opportunityOwnerId
      : '';
    result.opportunityOwner = body.opportunityOwner
      ? body.opportunityOwner
      : '';
    result.opportunityOwnerName = body.opportunityOwner
      ? body.opportunityOwner.name
      : '';
    result.opportunityOwnerIsDeleted = body.opportunityOwner
      ? body.opportunityOwner.isDeleted
      : false;
    result.serviceAmount = body.serviceAmount;
    result.opportunityCloseDate = body.opportunityCloseDate;
    result.canCreateOpportunity = body.canCreateOpportunity;
    result.opportunityCurrency = body.opportunityCurrency
      ? body.opportunityCurrency
      : '';
    result.opportunityCurrencyId = body.opportunityCurrencyId
      ? body.opportunityCurrencyId
      : '';
    result.opportunityCurrencyCode = body.opportunityCurrency
      ? body.opportunityCurrency.code
      : '';
    result.ecoSystem = body.ecoSystem ? body.ecoSystem : '';
    result.opportunityStatus = body.opportunityStatus;
    result.hasRevenueSchedule = body.hasRevenueSchedule;
    result.operationUnit = body.operationUnit ? body.operationUnit : null;
    result.opportunityURL = body.opportunityUrl;
    result.serviceBaseCurrencyAmount = body.serviceBaseCurrencyAmount;
    result.teamMessage = body.teamMessage ? body.teamMessage : '';
    result.teamStatus = body.teamStatus ? body.teamStatus : 0;
    result.externalTeamStatus = body.externalTeamStatus ? body.externalTeamStatus : 0;
    result.teamUrl = body.teamUrl ? body.teamUrl : '';
    result.opportunityURL = body.opportunityUrl;
    result.projectCode = body.projectCode;
    result.opportunityHasPrimaryKeyBuyer = body.opportunityHasPrimaryKeyBuyer;
    result.leadSourceId = body.leadSourceId;
    result.leadSource = body.leadSource;
    result.saveCloseOppFirstTime = body.saveCloseOppFirstTime;
    result.isChangeOrderOpportunity = body.isChangeOrderOpportunity;
    result.isMissingAccountSubmitted = body.isMissingAccountSubmitted;
    result.opportunityPrimaryKeyBuyerId = body.opportunityPrimaryKeyBuyerId;
    result.opportunityPrimaryKeyBuyerName = body.opportunityPrimaryKeyBuyer
      ? body.opportunityPrimaryKeyBuyer.name
      : '';
    result.opportunityPrimaryKeyBuyerTitle = body.opportunityPrimaryKeyBuyer
      ? body.opportunityPrimaryKeyBuyer.title
      : '';
    result.DRBURL = body.drburl ? body.drburl : null;
    result.winStrategyStatus = body.winStrategyStatus;
    result.winStrategyUrl = body.winStrategyUrl;
    result.teamSiteOption = body.teamSiteOption;
    result.externalTeamSiteOption=body.externalTeamSiteOption;
    result.externalTeamSiteName=body.externalTeamSiteName;
    result.externalTeamSiteId = body.externalTeamSiteId;
    result.teamSiteId = body.teamSiteId;
    result.hasOneToManyLinkedTeamSite = body.hasOneToManyLinkedTeamSite;
    result.engagementStatus = body.status;
    result.isTeamsPopUpEnabled = body.isTeamsPopUpEnabled;
    result.teamSiteName = body.teamSiteName;
    result.IsTeamsPrivateChannelEnabled = body.businessUnit.isTeamsPrivateChannelEnabled;
    result.accountType = body.accountType ? body.accountType : '';
    result.hasContracts = body.hasContractLinks;
    result.isProposalSubmitted = body.isProposalSubmitted;
    if (body.client) {
      result.accountId = body.client.accountId ? body.client.accountId : '';
      result.accountKey = body.client.accountKey ? body.client.accountKey : null;
      result.isGovernmentSanction = body.client.isGovernmentSanction;
    } else {
      result.accountId = '';
      result.accountKey = null;
    }
    result.probability = body.probability != null ? body.probability : null;
    result.userRole = body.userRole;
    result.SPOLinkURL = body.spoLinkURL ? body.spoLinkURL : null;
    if (body.businessUnit) {
      result.isInBudgetTool = body.businessUnit.isInBudgetTool;
      result.isContractEnabled = body.businessUnit.isContractEnabled;
    }

    if (body.riskAssessment) {
      result.riskAssessment = <IRiskAssessment>{};
      result.riskAssessment.id = body.riskAssessment
        ? body.riskAssessment.id
        : null;
      result.riskAssessment.url = body.riskAssessment
        ? body.riskAssessment.url
        : null;
      result.riskAssessment.name = body.riskAssessment
        ? body.riskAssessment.name
        : null;
      result.riskAssessment.status = body.riskAssessment.status
        ? body.riskAssessment.status
        : null;
      result.riskAssessmentUrl = result.riskAssessment.url; // riskAssessmentUrl could be from SF text box or iManage created ERA
      result.riskAssessmentId = body.riskAssessmentId
        ? body.riskAssessmentId
        : null; // this is same value as as body.riskAssessment.id above
      result.riskAssessmentName = body.riskAssessment
        ? body.riskAssessment.name
        : null;
    } else {
      // from SalesForce
      result.riskAssessmentUrl = body.riskAssessmentUrl
        ? body.riskAssessmentUrl
        : null;
    }
    result.hasActivatedSubBudget = body.hasActivatedBudgets;
    result.hasSubmittedOrActivatedSubBudget =
      body.hasSubmittedOrActivatedBudgets;

    //result.changeorderopportunities = [];
    //if (body.changeOrderOpportunities) {
    //    for (var i = 0; i < body.changeOrderOpportunities.length; i++) {
    //        result.changeorderopportunities.push(body.changeOrderOpportunities[i]);
    //    }
    //}

    result.opportunityServices = [];
    console.log(body.opportunityServices);
    if (body.opportunityServices) {
      for (let i = 0; i < body.opportunityServices.length; i++) {
        if (body.opportunityServices[i]) {
          result.opportunityServices.push({
            id: body.opportunityServices[i].id,
            serviceAmount: body.opportunityServices[i].serviceAmount,
            serviceOffering: body.opportunityServices[i].serviceOfferingId,
            engagementId: body.opportunityServices[i].engagementId,
            operationUnitCode: body.opportunityServices[i].operationUnit.code,
            solutionSegmentsName:
              body.opportunityServices[i].operationUnit.solutionSegments[0]
                .name,
            serviceOfferingsName:
              body.opportunityServices[i].operationUnit.solutionSegments[0]
                .serviceOfferings[0].name,
            serviceBaseCurrencyAmount:
              body.opportunityServices[i].serviceBaseCurrencyAmount,
            ordinal: body.opportunityServices[i].ordinal,
            revenueScheduleTotalAmount:
              body.opportunityServices[i].revenueScheduleTotalAmount,
          });
        }
      }

      // FOR IE
      result.opportunityServices.sort(function (a, b) {
        return a.ordinal - b.ordinal;
      });
      this.OpportunityServicesId = result.opportunityServices;
    }
    result.parent = body.parent;
    result.IaNaturalOfWork = body.iaNaturalOfWork;
    //result.isDigital = body.isDigital;
    result.isManagedService = body.isManagedService;
    result.highDemandOfferingId = body.highDemandOfferingId;
    result.ecosystemTypeOfWorks = body.ecosystemTypeOfWorks;
    result.isConfidential = body.isConfidential;
    result.isProposalUsed = body.isProposalUsed;
    result.canCreatePKICRequest = body.canCreatePKICRequest;
    result.canManage = body.canManage;
    result.canUpdate = body.canUpdate;
    result.canDelete = body.canDelete;
    result.canUnlinkEra = body.canUnlinkEra;
    result.modifiedDate = body.modifiedDate;
    result.modifier = body.modifier;
    result.createdDate = body.createdDate;
    result.status = body.status;
    result.creator = body.creator;
    result.type = body.type;
    result.canCreateMain = body.canCreateMain;
    result.requireAccessToClientDevices = body.requireAccessToClientDevices;

    if (
      result.clientId &&
      result.serviceOfferingId &&
      result.description &&
      result.IaNaturalOfWork &&
      result.ecoSystem &&
      //&& result.isDigital != null
      result.isManagedService != null
    ) {
      if (result.type == 0) {
        if (
          result.opportunityURL != null &&
          result.opportunityURL.length > 0 &&
          (result.opportunityURL
            .toLowerCase()
            .startsWith(this._configuration.validurl.toLowerCase() + '006') ||
            result.opportunityURL
              .toLowerCase()
              .startsWith(
                this._configuration.validlightningurl.toLowerCase() +
                  'r/opportunity/006',
              )) &&
          result.engagementManagerIsDeleted !== true &&
          result.engagementManagingDirectorIsDeleted !== true
        ) {
          result.allFieldsSaved = true;
        } else {
          result.allFieldsSaved = false;
        }
      } else if (result.type == 1) {
        if (
          result.name != null &&
          result.name != '' &&
          result.leadSourceId != null &&
          result.opportunityStageId != null &&
          result.opportunityStageId != '' &&
          result.opportunityCloseDate != null &&
          result.opportunityPrimaryKeyBuyerId != null &&
          result.OpportunityManagingDirectorIsDeleted !== true &&
          result.engagementManagerIsDeleted !== true &&
          result.opportunityOwnerIsDeleted !== true &&
          result.engagementManagingDirectorIsDeleted !== true &&
          result.requireAccessToClientDevices != null &&
          result.highDemandOfferingId != null &&
          result.ecoSystem &&
          (result.ecoSystem === 'N/A' || (result.ecosystemTypeOfWorks && result.ecosystemTypeOfWorks.length > 0))
          && result.economicBuyingCenterId) {
          result.allFieldsSaved = true;
        } else {
          result.allFieldsSaved = false;
        }
      }
    } else {
      result.allFieldsSaved = false;
    }

    result.allOpportunityFieldsSaved = body.canCreateOpportunity;
    this.currentShell = <IShell>{}; // this needed, otherwise error that currentShell is null
    this.currentShell = result;
    this.selectedBU = body.businessUnit ? body.businessUnit.name : '';

    result.proposals = [];

    result.dropdownValuesInEngagement = body.dropdownValuesInEngagement;
    result.isEmeaBU = body.businessUnit
      ? body.businessUnit.isInBudgetTool &&
        !body.businessUnit.isIntegratedWithiTrac
      : false;
    result.proposalDescription = body.proposalDescription;
    result.isResourceRequestEnabled = body.businessUnit
      ? body.businessUnit.isResourceRequestEnabled
      : false;

    result.isClientAcceptanceApprovalRequired =
      body.isClientAcceptanceApprovalRequired;
    result.isClientAcceptanceWorkflowEnalbed = body.businessUnit
      ? body.businessUnit.isClientAcceptanceWorkflowEnalbed
      : false;

    result.hasClientAcceptanceWorkflows = body.hasClientAcceptanceWorkflows;
    result.hasActiveClientAcceptanceWorkflows =
      body.hasActiveClientAcceptanceWorkflows;
    result.hasApprovedClientAcceptanceWorkflow =
      body.hasApprovedClientAcceptanceWorkflow;
    result.hasApprovingClientAcceptanceWorkflow =
      body.hasApprovingClientAcceptanceWorkflow;
    result.hasNotDraftClientAcceptanceWorkflow =
      body.hasNotDraftClientAcceptanceWorkflow;

    //result.clientAcceptanceWorkflows = [];
    //if (body.clientAcceptanceWorkflows) {
    //    for (var i = 0; i < body.clientAcceptanceWorkflows.length; i++) {
    //        result.clientAcceptanceWorkflows.push(body.clientAcceptanceWorkflows[i]);
    //    }
    //}
    return result;
  }

  setMenuActive() {
    if (this.currentShell.allFieldsSaved) {
      this.allFieldsSavedChange.next(true);
    } else {
      this.allFieldsSavedChange.next(false);
    }
    this.isMenuActivatedChange.next(true);
  }

  setMenuInactive() {
    this.isMenuActivatedChange.next(false);
  }

  setERAStatus(status: boolean) {
    this.ERAStatusChange.next(status);
  }

  //setBudgetsinAssistant() {
  //    if (this.currentShell.budgets) {
  //        this.budgetsChange.next(this.currentShell.budgets);
  //    }
  //}

  setShellsinAssistant(shells: any[]) {
    this.shellsChange.next(shells);
  }

  setClientId(client: any) {
    this.clientSelectedChange.next(client);
  }

  setLeadEMDId(employee: any) {
    this.leadEMDSelectedChange.next(employee);
  }

  setLeadEMId(employee: any) {
    this.leadEMSelectedChange.next(employee);
  }

  setOpportunityMDId(employee: any) {
    this.opportunityMDSelectedChange.next(employee);
  }

  setOpportunityOwnerId(employee: any) {
    this.opportunityOwnerSelectedChange.next(employee);
  }

  setOpportunityCurrencyId(currency: any) {
    this.opportunityCurrencySelectedChange.next(currency);
  }

  setPrimaryKeyBuyerId(pkb: any) {
    this.primaryKeyBuyerSelectedChange.next(pkb);
  }
  setNoContactPrimaryKeyBuyerChange(isNoContact: boolean) {
    this.noContactPrimaryKeyBuyerChange.next(isNoContact);
  }

  setNoAccountPrimaryKeyBuyerChange(isNoAccountClient: boolean) {
    this.noAccountPrimaryKeyBuyerChange.next(isNoAccountClient);
  }

  setServiceOfferingId(serviceOffering: any) {
    this.serviceOfferingSelectedChange.next(serviceOffering);
  }

  setLeadSourceId(leadSourceObj: any) {
    this.leadSourceSelectedChange.next(leadSourceObj);
  }

  setDepartmentId(department: any) {
    this.departmentSelectedChange.next(department);
  }

  setIndustryId(industry: any) {
    this.indsutrySelectedChange.next(industry);
  }

  setEcosystem(ecosystem: any) {
    this.ecosystemSelectedChange.next(ecosystem);
  }

  createBudget() {
    window.open(
      this.iBudgetUrl +
        'CreateCloneBudget?imanagecreatebudget&fromAssistant&ContractId=' +
        this.currentShell.id,
      '_top',
    );
  }

  copyBudget() {
    window.open(
      this.iBudgetUrl +
        'CreateCloneBudget?imanagecopybudget&fromAssistant&ContractId=' +
        this.currentShell.id,
      '_top',
    );
  }

  linkERA(redirectUrl?: string) {
    if (redirectUrl) {
      window.open(
        this.apiBaseUrl +
          'engagements/linkfilter?shellId=' +
          this.currentShell.id +
          '&redirectUrl=' +
          encodeURIComponent(redirectUrl),
        '_top',
      );
    } else {
      // inside iManage
      window.open(
        this.apiBaseUrl +
          'engagements/linkfilter?shellId=' +
          this.currentShell.id,
        '_top',
      );
    }
  }

  linkExistingBudget() {
    window.open(
      this.iBudgetUrl +
        'addbudgetstomain/index?&fromAssistant&ContractId=' +
        this.currentShell.id,
      '_top',
    );
  }

  goEra(id: string, name: string) {
    window.open(this.ERAUrl + name + '/' + id, '_top');
  }

  goShellHome() {
    window.open(this.apiBaseUrl, '_top');
  }

  goiManageTile() {
    window.open(this.apiBaseUrl, '_top');
  }

  constructor(
    private http: HttpClient,
    private _router: Router,
    private _configuration: Configuration,
  ) {
    if (!_configuration) {
      _configuration = new Configuration();
    }
    this.apiBaseUrl = _configuration.iManageApi;
    this.ERAFilterUrl = _configuration.eraServer;
    this.ERAUrl = _configuration.eraServer;
    this.iBudgetUrl = _configuration.iBudget;
    this.currentUrl = window.location.href;

    if (this.currentUrl.includes('assistant')) {
      this.type = this.getParameterByName('type', null);
    }

    this.headers = new HttpHeaders();
    this.headers = this.headers.append('Content-Type', 'application/json');
    this.headers = this.headers.append('Cache-control', 'no-cache');
    this.headers = this.headers.append('Cache-control', 'no-store');
    this.headers = this.headers.append('Expires', '0');
    this.headers = this.headers.append('Pragma', 'no-cache');
  }

  getParameterByName(name: string, url: string | null) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  createERA() {
    window.open(
      this.ERAUrl +
        '?erasetup=1&clientId=' +
        this.currentShell.clientId +
        '&em=' +
        this.currentShell.engagementManagerId +
        '&emd=' +
        this.currentShell.engagementManagingDirectorId +
        '&shellId=' +
        this.currentShell.id +
        '&eraName=' +
        encodeURIComponent(this.currentShell.name) +
        '&isConfidential=' +
        this.currentShell.isConfidential +
        '&description=',
      '_top',
    );
  }

  createPKICRequest() {
    window.open(
      this.apiBaseUrl +
        'pkicrequestform/' +
        this.currentShell.id +
        '?projectcode=' +
        this.currentShell.projectCode,
      '_blank',
    );
  }

  createOpportunity(): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    let newOpportunity = new IOppRequest();
    newOpportunity.engagementId = this.currentShell.id;
    let opportunityRequest = JSON.stringify(newOpportunity);
    return this.http.post(
      this.apiBaseUrl + this.createOpportunityUrl,
      opportunityRequest,
      { withCredentials: true, headers: this.headers },
    );
  }

  createOrderOpportunityForm(
    parentShellId: string,
    engagementView: IShell,
  ): Observable<any> {
    return this.http
      .post(
        this.apiBaseUrl +
          this.getShellUrl +
          '/' +
          parentShellId +
          '/changeorderopportunities',
        engagementView,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map((r) => {
          return r;
        }),
        catchError(this.handleError),
      );
  }

  getOrderOpportunityForm(
    parentShellId: string,
    orderOpportunityFormId: string,
  ): Observable<any> {
    return this.http
      .get(
        this.apiBaseUrl +
          this.getShellUrl +
          '/' +
          parentShellId +
          '/changeorderopportunities/' +
          orderOpportunityFormId,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(x=> {
          return this.extractDataToShellObject(x)
        }), 
        catchError(this.handleError));
  }

  updateOrderOpportunityForm(
    parentShellId: string,
    orderOpportunityFormId: string,
    engagementView: IShell,
  ): Observable<any> {
    if (engagementView.opportunityCloseDate) {
      if (typeof engagementView.opportunityCloseDate === 'string') {
        engagementView.opportunityCloseDate =
          engagementView.opportunityCloseDate.split('T')[0];
      } else {
        engagementView.opportunityCloseDate =
          engagementView.opportunityCloseDate.toDateString();
      }
    } else {
      engagementView.opportunityCloseDate = null;
    }
    return this.http
      .put(
        this.apiBaseUrl +
          this.getShellUrl +
          '/' +
          parentShellId +
          '/changeorderopportunities/' +
          orderOpportunityFormId,
        engagementView,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(x => {
          return this.extractDataToShellObject(x)
        }),
        catchError(this.handleError));
  }

  deleteChangeOrderOpportunity(
    parentShellId: string,
    orderOpportunityFormId: string,
  ): Observable<any> {
    return this.http
      .delete(
        this.apiBaseUrl +
          this.getShellUrl +
          '/' +
          parentShellId +
          '/changeorderopportunities/' +
          orderOpportunityFormId,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(catchError(this.handleError));
  }

  getBusinessUnits(): Observable<BusinessUnit[]> {
    return this.http
      .get(this.apiBaseUrl + this.businessUnitUrl, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map((r: any) => this.extractDataBusinessUnits), catchError(this.handleError));
  }

  getBusinessUnit(businessUnitId: string): Observable<BusinessUnit[]> {
    return this.http
      .get(this.apiBaseUrl + this.businessUnitUrl, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map((res) => this.extractDataBusinessUnit(res, businessUnitId)),
        catchError(this.handleError),
      );
  }
  getSelectedBusinessUnit(
    businessUnitId: string,
    departmentId: string,
  ): Observable<BusinessUnit> {
    return this.http
      .get(this.apiBaseUrl + this.businessUnitUrl + '/' + businessUnitId, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map((res) => this.extractSingleDataBusinessUnit(res, departmentId)),
        catchError(this.handleError),
      );
  }
  getIsRevenueRequireBU(businessUnitId: string): Observable<boolean> {
    return this.http
      .get(this.apiBaseUrl + this.businessUnitUrl + '/' + businessUnitId, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map((res) => this.extractIsRevenueRequireBU(res)),
        catchError(this.handleError),
      );
  }

  getBusinessUnitSearch(searchAll: string): Observable<BusinessUnit[]> {
    return this.http
      .get(this.apiBaseUrl + this.businessUnitUrl + '?searchAll=' + searchAll, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map((r: any) => this.extractDataBusinessUnits), catchError(this.handleError));
  }

  getIndustries(): Observable<Industry[]> {
    return this.http
      .get(this.apiBaseUrl + this.industryUrl, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map((r: any) => this.extractDataIndustries), catchError(this.handleError));
  }

  getIndustriesSearch(searchAll: string): Observable<Industry[]> {
    return this.http
      .get(this.apiBaseUrl + this.industryUrl + '?searchAll=' + searchAll, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map((r: any) => this.extractDataIndustries), catchError(this.handleError));
  }

  extractDataIndustries(response: HttpResponse<any>): Industry[] {
    let body = <any>response;
    let results: Industry[] = [];

    for (var i = 0; i < body.list.length; i++) {
      if (body.list[i].subIndustries) {
        for (var j = 0; j < body.list[i].subIndustries.length; j++) {
          let newDepartment: Industry = {
            name: body.list[i].subIndustries[j].name
              ? body.list[i].subIndustries[j].name
              : '',
            subIndustryId: body.list[i].subIndustries[j].id
              ? body.list[i].subIndustries[j].id
              : '',
            industryId: body.list[i].id,
            code: body.list[i].subIndustries[j].code
              ? body.list[i].subIndustries[j].code
              : '',
            industryName: body.list[i].name,
          };
          results.push(newDepartment);
        }
      }
    }
    return results;
  }

  extractDataBusinessUnits(response: HttpResponse<any>): BusinessUnit[] {
    let body = <any>response;
    let results: BusinessUnit[] = [];

    for (var i = 0; i < body.list.length; i++) {
      if (body.list[i].departments) {
        for (var j = 0; j < body.list[i].departments.length; j++) {
          let newDepartment: BusinessUnit = {
            name: body.list[i].departments[j].name
              ? body.list[i].departments[j].name
              : '',
            departmentId: body.list[i].departments[j].id
              ? body.list[i].departments[j].id
              : '',
            businessUnitId: body.list[i].id,
            code: body.list[i].departments[j].code
              ? body.list[i].departments[j].code
              : '',
            businessUnitName: body.list[i].name,
            currency: body.list[i].defaultCurrency,
            businessUnitDesc: body.list[i].country
              ? body.list[i].name + ' - ' + body.list[i].country
              : body.list[i].name,
            isInBudgetTool: body.list[i].isInBudgetTool,
            isIntegratedWithiTrac: body.list[i].isIntegratedWithiTrac,
            isRevenueScheduleRequired: body.list[i].isRevenueScheduleRequired,
            isClientAcceptanceWorkflowEnabled:
              body.list[i].isClientAcceptanceWorkflowEnabled,
            isResourceRequestEnabled: body.list[i].isResourceRequestEnabled
          };
          results.push(newDepartment);
        }
      }
    }

    return results;
  }

  extractDataBusinessUnit(
    response: any,
    businessUnitId: string,
  ): BusinessUnit[] {
    let body = <any>response;
    let results: BusinessUnit[] = [];
    for (var i = 0; i < body.list.length; i++) {
      if (body.list[i].id == businessUnitId && body.list[i].departments) {
        for (var j = 0; j < body.list[i].departments.length; j++) {
          let newDepartment: BusinessUnit = {
            name: body.list[i].departments[j].name
              ? body.list[i].departments[j].name
              : '',
            departmentId: body.list[i].departments[j].id
              ? body.list[i].departments[j].id
              : '',
            businessUnitId: body.list[i].id,
            code: body.list[i].departments[j].code
              ? body.list[i].departments[j].code
              : '',
            businessUnitName: body.list[i].name,
            currency: body.list[i].defaultCurrency,
            businessUnitDesc: body.list[i].country
              ? body.list[i].name + ' - ' + body.list[i].country
              : body.list[i].name,
            isInBudgetTool: body.list[i].isInBudgetTool,
            isIntegratedWithiTrac: body.list[i].isIntegratedWithiTrac,
            isRevenueScheduleRequired: body.list[i].isRevenueScheduleRequired,
            isClientAcceptanceWorkflowEnabled:
              body.list[i].isClientAcceptanceWorkflowEnabled,
            isResourceRequestEnabled: body.list[i].isResourceRequestEnabled
          };
          results.push(newDepartment);
        }
      }
    }

    return results;
  }

  extractSingleDataBusinessUnit(
    response: any,
    departmentId: string,
  ): BusinessUnit {
    let body = <any>response;
    let department = body.departments.filter((dep: any) => {
      return dep.id === departmentId;
    });
    let newDepartment: BusinessUnit = {
      name: department[0].name ? department[0].name : '',
      departmentId: department[0].id ? department[0].id : '',
      businessUnitId: body.id,
      code: department[0].code ? department[0].code : '',
      businessUnitName: body.name,
      currency: body.defaultCurrency,
      businessUnitDesc: body.country
        ? body.name + ' - ' + body.country
        : body.name,
      isInBudgetTool: body.isInBudgetTool,
      isIntegratedWithiTrac: body.isIntegratedWithiTrac,
      isClientAcceptanceWorkflowEnabled: body.isClientAcceptanceWorkflowEnalbed,
      isRevenueScheduleRequired: body.isRevenueScheduleRequired,
      isResourceRequestEnabled: body.isResourceRequestEnabled
    };
    return newDepartment;
  }

  extractIsRevenueRequireBU(response: any): boolean {
    let body = <any>response;
    return body.isRevenueScheduleRequired;
  }

  getIANatureList(): Observable<any[]> {
    return this.http
      .get(this.apiBaseUrl + this.IANatureUrl, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map((r: any) => this.extractIANature(r)), catchError(this.handleError));
  }

  extractIANature(response: HttpResponse<any>): any[] {
    let body = <any>response;
    let results = new Array();
    for (var i = 0; i < body.list.length; i++) {
      results.push({ id: body.list[i].name, name: body.list[i].name });
    }
    return results;
  }

  extractOpportunityList(response: any[]): any {
    let body = response;
    let results = new Array();
    results.push({
      id: '',
      name: '',
      probability: '',
      nameWithProbability: '',
      isRevenueScheduleRequired: false,
    });

    for (let i = 0; i < body.length; i++) {
      results.push({
        id: body[i].id,
        name: body[i].name,
        probability: body[i].probability,
        nameWithProbability: body[i].name + ' (' + body[i].probability + '%)',
        isRevenueScheduleRequired: body[i].isRevenueScheduleRequired,
      });
    }
    return results;
  }

  extractClosedList(response: any[]): any {
    let body = response;
    let results = new Array();

    for (let i = 0; i < body.length; i++) {
      results.push({
        id: body[i].id,
        name: body[i].name,
        probability: body[i].probability,
        primaryWLReasons: body[i].primaryWLReasons,
      });
    }
    return results;
  }

  extractOpportunityServices(response: any): any {
    let body = response;
    let result = new OpportunityServiceView();

    if (body) {
      result.id = body.id;
      result.serviceAmount = body.serviceAmount;
      result.serviceOfferingId = body.serviceOfferingId;
      result.serviceBaseCurrencyAmount = body.serviceBaseCurrencyAmount;
    }
    return result;
  }

  extractOpportunityCurrenciesList(response: any): any[] {
    let body = response;
    let results = new Array();
    for (let i = 0; i < body.list.length; i++) {
      results.push({
        id: body.list[i].id,
        code: body.list[i].code,
        name: body.list[i].name,
      });
    }
    return results;
  }

  extractPrimaryKeyBuyerList(response: any): any[] {
    if (!response) {
      return [];
    }
    let body = response;
    let results = new Array();
    for (let i = 0; i < body.list.length; i++) {
      results.push({
        id: body.list[i].id,
        title: body.list[i].title,
        name: body.list[i].name,
      });
    }
    return results;
  }

  extractEcosystemList(response: any): any[] {
    let body = response;
    let results = new Array();
    for (let i = 0; i < body.list.length; i++) {
      results.push({ id: body.list[i].id, name: body.list[i].name });
    }
    return results;
  }

  getOpportunityStageList(): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(this.apiBaseUrl + this.OpportunityStageUrl, {
        withCredentials: true,
        headers: headers,
      })
      .pipe(map((r: any) => this.extractOpportunityList(r)), catchError(this.handleError));
  }

  getClosedStages(): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(this.apiBaseUrl + this.OpportunityClosedStageUrl, {
        withCredentials: true,
        headers: headers,
      })
      .pipe(map((r: any) => this.extractClosedList(r)), catchError(this.handleError));
  }

  getOpportunityServices(id: string): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(this.apiBaseUrl + this.OpportunityServicesUrl + '/' + id, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(map(this.extractOpportunityServices), catchError(this.handleError));
  }

  private handleError(error: any): Observable<any> {
    console.log('handleError 789');
    console.log(error);
    return throwError(() => {error.status, error.error, error.statusText, error.message});
  }

  ngOnInit() {}

  saveShell(shell: IShell): Observable<IShell> {
    this.currentShell = shell;
    this.setERAStatus(true);
    this.createBudgetPOSTBody = shell; // body needs to include id of shell, for creating and copying budgets

    if (shell.id === GuidService.DEFAULT_EMPTY_GUID && this.currentShell.id == GuidService.DEFAULT_EMPTY_GUID) {
      shell.id = GuidService.DEFAULT_EMPTY_GUID; // need to convert to guid format, otherwise API won't accept POST request
      //Convert to string to get rid of timezone - created a date jump back for certain scenarios
      if (shell.opportunityCloseDate) {
        if (typeof shell.opportunityCloseDate === 'string') {
          shell.opportunityCloseDate = shell.opportunityCloseDate.split('T')[0];
        } else {
          shell.opportunityCloseDate =
            shell.opportunityCloseDate.toDateString();
        }
      } else {
        shell.opportunityCloseDate = null;
      }
      return this.createShell(shell, {withCredentials: true, headers: this.headers}).pipe(
        map(x => {
          return this.extractDataToShellObject(x)
        }), // map responses to shell
        catchError(this.handleError),
      );
    }

    shell.id = this.currentShell.id;
    return this.updateShell(shell, { withCredentials: true, headers: this.headers }).pipe(
      map(x => { 
        return this.extractDataToShellObject(x); 
      }), // map responses to shell
      catchError(this.handleError),
    );
  }

  private createShell(shell: IShell, options: any): Observable<any> {
    return this.http
      .post(this.apiBaseUrl + this.createShellUrl, shell, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map(function (r) {
          return r;
        }),
        tap((data) => (this.currentShell.id = (<any>data).id)), // need to refresh iframe after this
        catchError(this.handleError),
      );
  }

  public createPKICCDRRequest(
    account: AccountRequest,
  ): Observable<AccountRequest> {
    let toAdd = JSON.stringify(account);
    return this.http
      .post(
        this.apiBaseUrl +
          this.createAccountUrl +
          '/' +
          account.engagementId +
          '/cdr',
        toAdd,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map((res) => <AccountRequest>res),
        catchError(this.handleError),
      );
  }

  public saveRevenueSchedule(
    opportunityServiceId: any,
    revenueScheduleListView: RevenueScheduleListView,
  ): Observable<any> {
    if (
      !revenueScheduleListView ||
      !revenueScheduleListView.RevenueSchedules ||
      revenueScheduleListView.RevenueSchedules.length == 0
    ) {
      return of({});
    }
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .post(
        this.apiBaseUrl +
          this.OpportunityServicesUrl +
          '/' +
          opportunityServiceId +
          '/revenueschedules',
        revenueScheduleListView,
        { withCredentials: true, headers: headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        catchError(this.handleError),
      );
  }

  extractRevenueSchedule(response: any[]): any[] {
    let body = response;
    let results = new Array();
    for (let i = 0; i < body.length; i++) {
      results.push({
        id: body[i].id,
        amount: body[i].amount,
        comment: body[i].comment,
        startDate: body[i].startDate,
        endDate: body[i].endDate,
        ordinal: body[i].ordinal,
      });
    }
    return results;
  }

  public getRevenueScheduleItems(opportunityServiceId: any): Observable<any> {
    let url =
      this.apiBaseUrl +
      this.OpportunityServicesUrl +
      '/' +
      opportunityServiceId +
      '/revenueschedules';
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .get(url, { withCredentials: true, headers: headers })
      .pipe(map((response: any) => this.extractRevenueSchedule(response)), catchError(this.handleError));
  }

  public getRevenueSchedule(opportunityServiceId: any) {
    let url =`${this.apiBaseUrl}${this.OpportunityServicesUrl}/${opportunityServiceId}/revenueschedules?pageSize=30`;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map(function (r: any) {
          var json = r;
          return {
            data: json,
          };
        }),
      )
      .toPromise();
  }

  public updateRevenueSchedule(
    opportunityServiceId: any,
    revenueScheduleListView: RevenueScheduleListView,
  ): Observable<any> {
    if (
      !revenueScheduleListView ||
      !revenueScheduleListView.RevenueSchedules ||
      revenueScheduleListView.RevenueSchedules.length == 0
    ) {
      return of({});
    }
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .put(
        this.apiBaseUrl +
          this.OpportunityServicesUrl +
          '/' +
          opportunityServiceId +
          '/revenueschedules',
        revenueScheduleListView,
        { withCredentials: true, headers: headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        catchError(this.handleError),
      );
  }

  public removeRevenueSchedule(
    opportunityServiceId: any,
    revenueScheduleListViewId: string,
    body: string = '',
  ): Observable<any> {
    if (revenueScheduleListViewId != '') {
      return this.http
        .delete(
          this.apiBaseUrl +
            this.OpportunityServicesUrl +
            '/' +
            opportunityServiceId +
            '/revenueschedules' +
            '?revenueScheduleIds=' +
            revenueScheduleListViewId,
          { withCredentials: true, headers: this.headers },
        )
        .pipe(catchError(this.handleError));
    } else {
      return this.http
        .request(
          'DELETE',
          this.apiBaseUrl +
            this.OpportunityServicesUrl +
            '/' +
            opportunityServiceId +
            '/revenueschedules' +
            '?revenueScheduleIds=',
          { body: body, withCredentials: true, headers: this.headers },
        )
        .pipe(catchError(this.handleError));
    }
  }

  public createOpportunityServices(
    opportunityServices: OpportunityServiceView,
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .post(
        this.apiBaseUrl + this.OpportunityServicesUrl,
        JSON.stringify(opportunityServices),
        { withCredentials: true, headers: headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        catchError(this.handleError),
      );
  }

  public updateOpportunityServices(
    opportunityServices: OpportunityServiceView,
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .put(
        this.apiBaseUrl +
          this.OpportunityServicesUrl +
          '/' +
          opportunityServices.id,
        opportunityServices,
        { withCredentials: true, headers: headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        catchError(this.handleError),
      );
  }

  public removeOpportunityServices(
    opportunityServices: OpportunityServiceView,
  ): Observable<any> {
    return this.http
      .delete(
        this.apiBaseUrl +
          this.OpportunityServicesUrl +
          '/' +
          opportunityServices.id,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        catchError(this.handleError),
      );
  }

  public createAccount(account: AccountRequest): Observable<AccountRequest> {
    let toAdd = JSON.stringify(account);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Cache-control', 'no-store');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .post(this.apiBaseUrl + this.createAccountUrl, toAdd, {
        withCredentials: true,
        headers: headers,
      })
      .pipe(
        map((res) => <AccountRequest>res),
        catchError(this.handleError),
      );
  }

  getUploadFileById(fileId: string): Observable<UploadView> {
    let parameters: HttpParams = new HttpParams();
    parameters = parameters.set('id', fileId);

    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Cache-control', 'no-store');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');

    return this.http.get<UploadView>(
      `${this.apiBaseUrl}${this.uploadUrl}/${fileId}`,
      { withCredentials: true, headers: headers },
    );
  }

  public uploadFileService(
    formData: any,
    containerId: string,
    fileType: string,
    newFileName: string,
    id: any,
  ): Observable<any> {
    let parameters: HttpParams = new HttpParams();
    parameters = parameters.set('containerId', containerId);
    parameters = parameters.set('fileType', fileType);
    parameters = parameters.set('newFileName', newFileName);
    if (!id) {
      id = Guid.create();
    }
    parameters = parameters.set('id', String(id));
    var headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Cache-control', 'no-store');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .post(this.apiBaseUrl + this.uploadUrl, formData, {
        withCredentials: true,
        headers: headers,
        params: parameters,
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  public batchUploadFileService(
    formData: any,
    containerId: string,
    fileType: string,
  ): Observable<any> {
    let parameters: HttpParams = new HttpParams();
    parameters = parameters.set('containerId', containerId);
    parameters = parameters.set('fileType', fileType);
    var headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Cache-control', 'no-store');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .post(this.apiBaseUrl + this.bathUploadUrl, formData, {
        withCredentials: true,
        headers: headers,
        params: parameters,
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  public updateFileService(id: string, newFileName: string){
    const data = { newFileName: newFileName };
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Cache-control', 'no-store');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http.put(this.apiBaseUrl + this.uploadUrl + `/${id}`, data, {
      withCredentials: true,
      headers,
    });
  }

  public deleteFileService(
    containerId: string,
    fileType: string,
    deleteFileName: string,
  ): Observable<any> {
    let parameters: HttpParams = new HttpParams();
    parameters = parameters.set('containerId', containerId);
    parameters = parameters.set('fileType', fileType);
    parameters = parameters.set('deleteFileName', deleteFileName);
    var headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Cache-control', 'no-store');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .delete(this.apiBaseUrl + this.uploadUrl, {
        withCredentials: true,
        headers: headers,
        params: parameters,
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  getUploadFileService(containerId: any, type: number) {
    let url = this.apiBaseUrl + this.uploadUrl;
    let parameters: HttpParams = new HttpParams();
    parameters = parameters.set(
      'filters',
      'ContainerId eq ' + containerId + ';;Type eq ' + type,
    );
    parameters = parameters.set('sort', 'name');
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http
      .get(url, {
        withCredentials: true,
        headers: this.headers,
        params: parameters,
      })
      .pipe(
        map(function (r: any) {
          var json = r;
          return {
            data: json,
          };
        }),
      )
      .toPromise();
  }

  // folderName is container name in Azure blob storage
  public downloadFileService(
    containerId: any,
    downloadFileName: string,
    folderName: string,
  ): Observable<Blob> {
    let url =
      this.apiBaseUrl +
      this.uploadUrl +
      '/' +
      containerId +
      '/' +
      folderName +
      '/' +
      downloadFileName;
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http.get(url, {
      withCredentials: true,
      headers: this.headers,
      responseType: 'blob',
    });
  }

  public downloadFileServiceById(
    containerId: any,
    downloadFileId: string,
    folderName: string,
  ): Observable<Blob> {
    let url =
      this.apiBaseUrl +
      this.uploadUrl +
      '/' +
      containerId +
      '/' +
      folderName +
      '/fileid/' +
      downloadFileId;
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Cache-control', 'no-cache');
    headers = headers.append('Expires', '0');
    headers = headers.append('Pragma', 'no-cache');
    return this.http.get(url, {
      withCredentials: true,
      headers: this.headers,
      responseType: 'blob',
    });
  }

  // only called after initial create/save, not for iframe, and not for loading existing shell, to update assistant
  reloadIframe2(shellId: string) {
    this.modalRevenueScheduleAmount = [];
    this.getShell(shellId).subscribe(
      (shell: IShell) => {
        let shells: Array<IShell> = new Array<IShell>();
        shells.push(shell);
        this.assistantChange.next(shells);
        if (this.currentShell.opportunityServices != null) {
          for (
            var i = 0;
            i < this.currentShell.opportunityServices.length;
            i++
          ) {
            this.extractRevenueScheduleAmount(
              this.currentShell.opportunityServices[i].id,
              i,
            );
          }
        }
      },
      (error: any) => {
        this.errorMessage = <any>error;
        alert(ErrorMessagesConstants.APP_MESSAGES.REQUEST_ACCESS);
        this._router.navigate([APIUrlConstants.SHELL_FILTER], {});
      },
    );
  }

  reloadIframeForOrderOpportunity(
    parentShellId: string,
    orderOpportunityId: string,
  ) {
    this.modalRevenueScheduleAmount = [];
    this.getOrderOpportunityForm(parentShellId, orderOpportunityId).subscribe(
      (shell: IShell) => {
        let shells: Array<IShell> = new Array<IShell>();
        shells.push(shell);
        this.assistantChange.next(shells);
        if (this.currentShell.opportunityServices != null) {
          for (
            var i = 0;
            i < this.currentShell.opportunityServices.length;
            i++
          ) {
            this.extractRevenueScheduleAmount(
              this.currentShell.opportunityServices[i].id,
              i,
            );
          }
        }
      },
      (error: any) => {
        this.errorMessage = <any>error;
        alert(ErrorMessagesConstants.APP_MESSAGES.REQUEST_ACCESS);
        this._router.navigate(['/engagements/shellFilter'], {});
      },
      () => {
        this.getShell(parentShellId).subscribe((shell: IShell) => {
          this.loadAssistant(shell);
        });
      },
    );
  }

  updateAccountClient(clientId: string): Observable<any> {
    return this.http
      .get(this.apiBaseUrl + this.clientUrl + '/' + clientId, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(catchError(this.handleError));
  }

  private updateShell(shell: IShell, options: any): Observable<any> {
    return this.http
      .put(
        this.apiBaseUrl + this.createShellUrl + '/' + this.currentShell.id,
        JSON.stringify(shell),
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        //map(this.extractDataToShellObject),
        tap(),
      );
  }

  deleteDraft(): Observable<any> {
    return this.http
      .delete(this.apiBaseUrl + this.getShellUrl + '/' + this.currentShell.id, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(
        map(function (r: any) {
          return r;
        }),
        catchError(this.showDeleteError),
      );
  }

  private showDeleteError(error: any): Observable<any> {
    alert(
      'Record cannot be deleted when objects are linked.  Please unlink objects through the iManage Assistant and retry.',
    );
    return observableThrowError(error);
  }

  //public linkCollaborationtoShell(shell: IShell, redirectUrl?: string): Observable<any> {
  //    this.linkCollaborationtoShellHelper(shell)
  //        .subscribe(() => {
  //            if (typeof redirectUrl != 'undefined' || redirectUrl != null) {
  //                window.open(redirectUrl, '_top');
  //            }
  //            else {
  //                if (shell.type == 1) {
  //                    this.router.navigate([APIUrlConstants.SHELL_EDIT + '/' + shell.id], {});
  //                }
  //                else if (shell.type == 0) {
  //                    this.router.navigate([APIUrlConstants.SHELL_LINKEXISTING + shell.id], {});
  //                }
  //            }
  //        },  // route depends on calling origin
  //            (error: any) => this.errorMessage = <any>error
  //        );
  //}

  public linkCollaborationtoShellHelper(shell: IShell): Observable<any> {
    return this.http
      .patch(
        this.apiBaseUrl + this.getShellUrl + '/' + shell.id,
        [
          {
            op: 'replace',
            path: '/TeamSiteId',
            value: shell.teamSiteId,
          },
        ],
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        tap(() => {
          console.log('1087 linkCollaborationtoShellHelper success');
        }),
      );
  }

  public linkERAtoShell(shell: IShell, redirectUrl?: string) {
    this.linkERAtoShellHelper(shell).subscribe(
      () => {
        if (typeof redirectUrl != 'undefined' || redirectUrl != null) {
          window.open(redirectUrl, '_top');
        } else {
          if (shell.type == 1) {
            this._router.navigate(
              [APIUrlConstants.SHELL_EDIT + '/' + shell.id],
              {},
            );
          } else if (shell.type == 0) {
            this._router.navigate(
              [APIUrlConstants.SHELL_LINKEXISTING + shell.id],
              {},
            );
          }
        }
      }, // route depends on calling origin
      (error: any) => (this.errorMessage = <any>error),
    );
  }

  public updateProposalDescription(id: string, desc: string): Observable<any> {
    return this.http
      .put(
        this.apiBaseUrl +
          this.uploadUrl +
          '/' +
          id +
          '/UpdateProposalDescription',
        JSON.stringify({ proposalDescription: desc }),
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        tap(),
        catchError(this.handleError),
      );
  }

  public linkERAtoShellHelper(shell: IShell): Observable<any> {
    return this.http
      .patch(
        this.apiBaseUrl + this.getShellUrl + '/' + shell.id,
        [
          {
            op: 'replace',
            path: '/RiskAssessmentId',
            value: shell.riskAssessmentId,
          },
        ],
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        tap(() => {
          console.log('1087 linkERAtoShellHelper success');
        }),
        catchError(this.handleError),
      );
  }

  public setOpportunityUrl() {
    if (this.currentShell.opportunityURL) {
      this.opportunityChange.next(this.opportunityURL);
    }
  }

  public setTeamsSiteOption(shell: IShell): Observable<any> {
    const patchData = [
      {
        op: 'replace',
        path: '/TeamSiteOption',
        value: shell.teamSiteOption,
      },
      {
        op: 'replace',
        path: '/ExternalTeamSiteOption',
        value: shell.externalTeamSiteOption,
      },
    ];
    return this.http
      .patch(
        this.apiBaseUrl + this.getShellUrl + '/' + shell.id,
        patchData,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(
        map(function (r: any) {
          return r;
        }),
        tap(() => {
          console.log('not required team status set');
        }),
        catchError(this.handleError),
      );
  }

  public loadAssistant(shell: IShell) {
    let shells: Array<IShell> = new Array<IShell>();
    shells.push(shell);
    this.assistantChange.next(shells);
  }

  public linkSalesForcetoShell(shell: IShell, redirectUrl: string) {
    this.saveShell(shell).subscribe(
      () => {
        if (redirectUrl) {
          window.open(redirectUrl, '_top');
        } else {
          this.setERAStatus(false);
          if (this.currentShell.type == 1) {
            this._router.navigate(
              [
                APIUrlConstants.SHELL_EDIT +
                  '/' +
                  this.currentShell.id +
                  '?' +
                  Math.random(),
              ],
              {},
            );
          } else if (this.currentShell.type == 0) {
            this._router.navigate(
              [
                APIUrlConstants.SHELL_LINKEXISTING +
                  this.currentShell.id +
                  '?' +
                  Math.random(),
              ],
              {},
            );
          }
        }
      },
      (error: any) => (this.errorMessage = <any>error),
    );
  }

  getOpportunityCurrenciesList(): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(this.apiBaseUrl + this.opportunityCurrenciesUrl, {
        withCredentials: true,
        headers: headers,
      })
      .pipe(
        map(this.extractOpportunityCurrenciesList),
        catchError(this.handleError),
      );
  }

  getOpportunityCurrenciesSearch(searchAll: string): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(
        this.apiBaseUrl +
          this.opportunityCurrenciesUrl +
          '&searchAll=' +
          searchAll,
        { withCredentials: true, headers: headers },
      )
      .pipe(
        map(this.extractOpportunityCurrenciesList),
        catchError(this.handleError),
      );
  }

  getEcosystemList(): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(this.apiBaseUrl + this.ecosystemUrl + '?pageSize=100', {
        withCredentials: true,
        headers: headers,
      })
      .pipe(map(this.extractEcosystemList), catchError(this.handleError));
  }

  getEcosystemSearch(searchAll: string): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(
        this.apiBaseUrl +
          this.ecosystemUrl +
          '?pageSize=100&searchAll=' +
          searchAll,
        { withCredentials: true, headers: headers },
      )
      .pipe(map(this.extractEcosystemList), catchError(this.handleError));
  }

  getPrimaryKeyBuyerList(clientId: string): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(this.apiBaseUrl + 'api/clients/' + clientId + '/contacts', {
        withCredentials: true,
        headers: headers,
      })
      .pipe(map(this.extractPrimaryKeyBuyerList), catchError(this.handleError));
  }

  getPrimaryKeyBuyerSearch(
    clientId: string,
    searchAll: string,
  ): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get(
        this.apiBaseUrl +
          'api/clients/' +
          clientId +
          '/contacts' +
          '?searchAll=' +
          searchAll,
        { withCredentials: true, headers: headers },
      )
      .pipe(map(this.extractPrimaryKeyBuyerList), catchError(this.handleError));
  }

  public refreshChecklist() {
    if (this.currentShell.type == 1)
      window.location.href =
        APIUrlConstants.SHELL_EDIT + '/' + this.currentShell.id;
    else
      window.location.href =
        APIUrlConstants.SHELL_LINKEXISTING + this.currentShell.id;
  }

  // Return an initialized object
  // initializeBlankShell(): IShell {
  //   return {
  //     id: null,
  //     name: null,
  //     clientId: null,
  //     clientNameSalesForceUrl: '',
  //     clientName: '',
  //     client: null,
  //     description: null,
  //     budgetStatus: 0,
  //     businessUnitId: null,
  //     businessUnitName: '',
  //     businessUnitCurrency: '',
  //     businessUnit: null,
  //     isRevenueScheduleRequiredForBU: false,
  //     engagementManagingDirectorId: null,
  //     engagementManagingDirectorName: '',
  //     engagementManagingDirectorIsDeleted: false,
  //     engagementManagerId: null,
  //     engagementManagerName: '',
  //     engagementManagerIsDeleted: false,
  //     externalTeamMessage: '',
  //     externalTeamStatus: 0,
  //     externalTeamUrl: '',
  //     externalTeamSiteId: null,
  //     externalTeamSiteName: '',
  //     externalTeamSiteOption: 0,
  //     enterpriseCollaborators: '',
  //     departmentId: null,
  //     departmentName: '',
  //     salesforceUrl: '',
  //     solutionId: null,
  //     solutionName: '',
  //     solutionCode: '',
  //     solutionSegmentId: null,
  //     solutionSegmentName: '',
  //     serviceOfferingId: null,
  //     serviceOfferingName: '',
  //     IaNaturalOfWork: null,
  //     TransactionService: null, // NOT NEEDED, KEEPING HERE FOR NOW OR ASSISTANT WILL THROW ERROR
  //     isConfidential: null,
  //     plannedClosedDate: null,
  //     riskAssessmentId: null,
  //     riskAssessmentUrl: null,
  //     riskAssessment: null,
  //     riskAssessmentName: null,
  //     canCreatePKICRequest: false,
  //     canManage: false,
  //     canCreateOpportunity: false,
  //     canUpdate: false,
  //     canDelete: false,
  //     canUnlinkEra: false,
  //     canUnlinkOpportunity: false,
  //     hasActivatedSubBudget: false,
  //     budgets: null,
  //     shells: null,
  //     opportunityServices: null,
  //     isInBudgetTool: false,
  //     isTeamsEnabled: false,
  //     status: '',
  //     modifiedDate: '',
  //     modifier: new Employee(),
  //     createdDate: '',
  //     creator: new Employee(),
  //     shellUrl: '',
  //     isDigital: false,
  //     isManagedService: false,
  //     isProposalUsed: null,
  //     opportunityStageId: null,
  //     primaryWinLossReasonId: null,
  //     opportunityStageName: null,
  //     opportunityStageProbability: null,
  //     allFieldsSaved: false,
  //     allOpportunityFieldsSaved: false,
  //     serviceAmount: null,
  //     closedDate: null,
  //     opportunityCloseDate: null,
  //     opportunityOwnerId: null,
  //     opportunityOwner: null,
  //     opportunityOwnerName: null,
  //     opportunityOwnerIsDeleted: false,
  //     opportunityCurrency: null,
  //     opportunityCurrencyId: null,
  //     opportunityCurrencyCode: null,
  //     opportunityStatus: null,
  //     opportunityURL: null,
  //     hasRevenueSchedule: false,
  //     operationUnit: null,
  //     serviceBaseCurrencyAmount: null,
  //     OpportunityManagingDirectorId: null,
  //     OpportunityManagingDirectorName: '',
  //     OpportunityManagingDirectorIsDeleted: false,
  //     type: null,
  //     teamMessage: '',
  //     teamStatus: 0,
  //     teamUrl: '',
  //     projectCode: null,
  //     opportunityHasPrimaryKeyBuyer: false,
  //     probability: null,
  //     leadSource: null,
  //     leadSourceId: '',
  //     saveCloseOppFirstTime: false,
  //     changeorderopportunities: null,
  //     isChangeOrderOpportunity: false,
  //     canCreateMain: false,
  //     parent: null,
  //     accountId: null,
  //     isMissingAccountSubmitted: false,
  //     accountKey: null,
  //     userRole: null,
  //     ecoSystem: null,
  //     opportunityPrimaryKeyBuyerId: null,
  //     opportunityPrimaryKeyBuyerName: null,
  //     opportunityPrimaryKeyBuyerTitle: null,
  //     DRBURL: null,
  //     winStrategyStatus: 0,
  //     winStrategyUrl: null,
  //     proposals: null,
  //     dropdownValuesInEngagement: null,
  //     isEmeaBU: false,
  //     proposalDescription: null,
  //     isResourceRequestEnabled: false,
  //     teamSiteId: null,
  //     teamSiteOption: null,
  //     isTeamsPopUpEnabled: false,
  //     hasOneToManyLinkedTeamSite: false,
  //     teamSiteName: null,
  //     IsTeamsPrivateChannelEnabled: false,
  //     isClientAcceptanceWorkflowEnalbed: false,
  //     accountType: null,
  //     clientAcceptanceWorkflows: null,
  //     isClientAcceptanceApprovalRequired: false,
  //     hasContracts: false,
  //     isContractEnabled: false,
  //     hasClientAcceptanceWorkflows: false,
  //     hasActiveClientAcceptanceWorkflows: false,
  //     hasApprovedClientAcceptanceWorkflow: false,
  //     hasApprovingClientAcceptanceWorkflow: false,
  //     hasSubmittedOrActivatedSubBudget: false,
  //     SPOLinkURL: null,
  //     hasNotDraftClientAcceptanceWorkflow: false,
  //     requireAccessToClientDevices: null,
  //     isProposalSubmitted: null,
  //     highDemandOfferingId: null,
  //     ecosystemTypeOfWorks: [],
  //     economicBuyingCenterId: null,
  //     economicBuyingCenterOther: null,
  //     isGovernmentSanction: false,
  //     engagementStatus: '',
  //     isTarget:null
  //   };
  // }

  private SaveShellTrigger = new Subject<boolean>();
  SaveShellTrigger$ = this.SaveShellTrigger.asObservable();
  public callShellSave(save: boolean) {
    this.SaveShellTrigger.next(save);
  }

  private cpaSubmitErrorTrigger = new Subject<boolean>();
  cpaSubmitErrorTrigger$ = this.cpaSubmitErrorTrigger.asObservable();
  public cpaSubmitError(msg: boolean) {
    this.cpaSubmitErrorTrigger.next(msg);
  }

  public getConfiguration(): Configuration {
    if (!this._configuration) {
      this._configuration = new Configuration();
    }
    return this._configuration;
  }

  getAnnouncements(): Observable<any> {
    return this.http
      .get(this.apiBaseUrl + 'api/configurations/announcements', {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(tap(), catchError(this.handleError));
  }

  updateAnnouncements(announcement: any, announcementId: any): Observable<any> {
    let announcementsJson = JSON.stringify(announcement);
    return this.http
      .put(
        this.apiBaseUrl + 'api/configurations/' + announcementId,
        announcementsJson,
        { headers: this.headers },
      )
      .pipe(
        map(() => announcement),
        tap(),
      );
  }
  sendAccesRequest(id: string): Observable<any> {
    return this.http
      .post(
        this.apiBaseUrl + this.getShellUrl + '/' + id + '/requestpermission',
        { headers: this.headers },
      )
      .pipe(catchError(this.handleError));
  }
  getClientSetupFormLink(): Observable<any> {
    return this.http
      .get(this.apiBaseUrl + 'api/configurations/system', {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(tap(), catchError(this.handleError));
  }

  getClient(id: string): Observable<any> {
    return this.http
      .get(this.apiBaseUrl + 'api/clients/' + id, {
        withCredentials: true,
        headers: this.headers,
      })
      .pipe(tap(), catchError(this.handleError));
  }

  getTeamSites(id: string, isInternal: boolean): Observable<any> {
    return this.http
      .get(
        this.apiBaseUrl +
          'api/engagements/' +
          id +
          '/teamsites?isInternal=' +
          isInternal,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(tap(), catchError(this.handleError));
  }

  getEngagementsByTeamSiteId(id: string): Observable<any> {
    return this.http
      .get(
        this.apiBaseUrl +
          'api/engagements/' +
          'getEngagementsByTeamSiteId/' +
          id,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(tap(), catchError(this.handleError));
  }

  getOpportunityStatusList(): Observable<any[]> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this.http
      .get<any[]>(this.apiBaseUrl + this.OpportunityStageUrl, {
        withCredentials: true,
        headers: headers,
      })
      //.pipe(catchError(this.handleError));
  }

  createTeamsSite(id: string, name: string, isInternal: boolean): Observable<any> {
    return this.http
      .post(
        this.apiBaseUrl + 'api/engagements/' + id + '/teamsite?name=' + name+ '&isInternal=' + isInternal,
        { withCredentials: true, headers: this.headers },
      )
      .pipe(catchError(this.handleError));
  }

  engagementResponseToShellObject(engagement: IShell): IShell {
    return this.extractDataToShellObject(engagement);
  }

  closeClientAccWorkflow(id: string, cawId: string): Observable<any> {
    return this.http
      .delete(
        this.apiBaseUrl +
          'api/engagements/' +
          id +
          '/clientacceptanceworkflow/' +
          cawId +
          '/close',
        { withCredentials: true, headers: this.headers },
      )
      .pipe(catchError(this.handleError));
  }

  getAdditionalClosedWinLossOptions(): Observable<any[3]> {
    return this.http
      .get(
        this.apiBaseUrl + 'api/dropdownvalues/additionalclosedwinlossoptions',
        { withCredentials: true, headers: this.headers },
      )
      .pipe(catchError(this.handleError));
  }

  getHighDemandOffereingOptions(): Observable<GenericDropdown[]> {
    return this.http.get<GenericDropdown[]>(`${this.apiBaseUrl}api/dropdownvalues/highdemandofferings`, { withCredentials: true, headers: this.headers })
  }

  getEcosystemTypeOfWorkOptions(): Observable<GenericDropdown[]> {
    return this.http.get<GenericDropdown[]>(`${this.apiBaseUrl}api/dropdownvalues/ecosystemtypeofworks`, { withCredentials: true, headers: this.headers })
  }

  getEconomicBuyingCenterOptions(): Observable<GenericDropdown[]> {
    return this.http.get<GenericDropdown[]>(`${this.apiBaseUrl}api/dropdownvalues/economicbuyingcenter`, { withCredentials: true, headers: this.headers })
  }

  // getAdditionalClosedWinLossContext(
  //   engagementId: string,
  //   parentId: string,
  // ): Observable<AdditionalWinLossContext> {
  //   return this.http
  //     .get<AdditionalWinLossContext>(
  //       this.apiBaseUrl +
  //         'api/engagements/' +
  //         engagementId +
  //         '/additionalwinloss?parentId=' +
  //         (parentId ? parentId : ''),
  //       { withCredentials: true, headers: this.headers },
  //     )
  //     //.pipe(catchError(this.handleError));
  // }

  // updateAdditionalClosedWinLossContext(additionalClosedWinLoss: AdditionalWinLossContext, parentId: string): Observable<AdditionalWinLossContext> {
  //   let additionalClosedWinLossJson = JSON.stringify(additionalClosedWinLoss);
  //   console.log('saving');
  //   //return this.http.post(this.apiBaseUrl + 'api/engagements/' + additionalClosedWinLoss.engagementKey + '/additionalwinloss/', additionalClosedWinLossJson, { headers: this.headers }).pipe(
  //   //    catchError(this.handleError))

  //   return this.http.post(`${this.apiBaseUrl}api/engagements/${additionalClosedWinLoss.engagementKey}/additionalwinloss?parentId=${(parentId ? parentId : '')}`,
  //     additionalClosedWinLossJson, { withCredentials: true, headers: this.headers }).pipe(
  //       map((r: any) => {
  //         return r;
  //       }),
  //       catchError(this.handleError),
  //     );
  // }

  getBudgets(id: string) {
    let url = this.apiBaseUrl + this.engagementUrl + id + '/budgets';
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map((response: any) => response),
        catchError(this.handleError),
      );
  }
  getChangeOrderOpprs(id: string) {
    let url =
      this.apiBaseUrl + this.engagementUrl + id + '/changeorderopportunities';
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map((response: any) => response),
        catchError(this.handleError),
      );
  }

  getClientAcceptanceWorkflows(id: string) {
    let url =
      this.apiBaseUrl + this.engagementUrl + id + '/clientacceptanceworkflows';
    return this.http
      .get(url, { withCredentials: true, headers: this.headers })
      .pipe(
        map((response: any) => response),
        catchError(this.handleError),
      );
  }

  disableDeletebtn(shell: IShell, editPermissionUserRole: boolean): string {
    if (!shell) return '';
    if (editPermissionUserRole) {
      return '';
    }
    //Condition : iManage Shell's Main Budget is Closed
    if (shell.closedDate != null) {
      return '';
    } else if (shell.hasNotDraftClientAcceptanceWorkflow) {
      /*Main Budget is Open or has no Main Budget yet and a linked not deleted CPA form in a stage other than Draft*/
      // CPA stage
      return 'Shell cannot be deleted once there is a linked Client Pursuit Acceptance form.';
    } else if (shell.opportunityStatus == 1) {
      return 'The iManage shell cannot be deleted while the Salesforce Opportunity creation is in progress.';
    } else if ((shell.opportunityStatus == 2 || shell.opportunityStatus == 3 || shell.type == 0) && !shell.canDelete) {
      return 'Related objects must be deleted or unlinked to delete the iManage shell (e.g. ERA, DRB, sub budgets, change orders, proposal documents, contract documents).';
    }
    return '';
  }
}
